export const visit = (vm, at) => {
at({ "ca-es": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} de {{totalBytes}}" }, "fileSizeLimit": "El fitxer no pot ser superior a {{size}}", "screenCapture": "Captura de pantalla" } } });
};